declare global {
    interface Window {
        dataLayer?: Array<Record<string, unknown>>;
        recordsSettings: {
            basePageTitle: string;
            franchiseScopedRestUrl: string;
            franchiseTricode: string;
        };
        googleAnalyticsSettings: {
            trackingId: string;
        };
        __REDUX_DEVTOOLS_EXTENSION__?: any;
    }
}

export type Option = {
    active?: boolean;
    label: string;
    value: string;
};

export enum ComponentSeasonTypes {
    AllStarTeams = 'AllStarTeams',
    Base = 'Base',
    Draft = 'Draft',
    Playoffs = 'Playoffs',
    Records = 'Records',
    StanleyCupChampion = 'StanleyCupChampion',
}

export type ComponentSeason = {
    id: ComponentSeasonTypes;
    component: string;
    gameTypeId: number;
    seasonId: number;
};

export type Logo = {
    id: number;
    background: string;
    endSeason: number;
    secureUrl: string;
    startSeason: number;
    teamId: number;
    url: string;
};

export type GameFormat = {
    id: number;
    info: string;
    maxPeriod?: number;
    otPeriodSeconds: number;
    otSkatersPerSide: number;
    overtimeInUse: number;
    regulationPeriodSeconds: number;
    regulationPeriods: number;
    regulationSkatersPerSide: number;
    shootoutInUse: number;
    shootoutRoundsBeforeSuddenDeath?: number;
    suddenDeathOtInUse: number;
    tiesInUse: number;
};

export type Expanded = {
    current: boolean;
    desired: boolean;
};
